module.exports = __webpack_public_path__ + "static/media/piqipi.0e04d149.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/piqipi.png
// module id = 489
// module chunks = 0